import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquarePlus, faSquareMinus, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import bus from '../assets/mdi--bus.png';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CustomToastContainer from '../components/CustomToastContainer.js';
import { generateTopupInvoice, getMeeznaFormUrl } from '../apiServices/apiServices.js';

const OnRideTopup = () => {
    const navigate = useNavigate();
    const [user_id, setUserId] = useState('');
    const [amount, setAmount] = useState(500); 
    const [totalAmount, setTotalAmount] = useState(500*1.026); 
    const [isCustom, setIsCustom] = useState(false); 
    const [ride_code, setRideCode] = useState('');

    const handleProceed = async (e) => {
        e.preventDefault();

        if(amount < 50) {
            toast.error("Minimum recharge amount is PKR 50.0");
            return
        }

        const user = JSON.parse(window.localStorage.getItem("user"));
        // console.log("Userid", user.id)
        setUserId(user.id)
        try {        
            const response = await getMeeznaFormUrl(amount);
            console.log("Response ...: ", response);
            if (response && response.success) {
            //   window.location.replace("/wallet"); 
                window.location.href = response.data.form_url;
            } else {
              console.error("Request failed or unexpected response structure", response);
              toast.error(response.message || "Request failed");
            }
            
        } catch (error) {
            console.error('Error logging in:', error);
            toast.error('An error occurred. Please try again.');
        }
    };

    const handleAmountChange = (newAmount) => {
        setIsCustom(false)
        setAmount(newAmount);
        setTotalAmount((newAmount * 1.026).toFixed(2))
    };

    const handleCustom = () => {
        setIsCustom(true);
    };

    const incrementAmount = () => {
        var tAmount = amount
        if (tAmount + 500 <= 10000) {
            tAmount = tAmount + 500;
        } else {
            toast.warn("Maximum amount reached!"); 
            return; 
        }
        setAmount(tAmount);
        setTotalAmount((tAmount * 1.026).toFixed(2))
    };

    const decrementAmount = () => {
        var tAmount = amount
        if (tAmount - 500 > 0) {
            tAmount = tAmount - 500;
        } else {
            return; 
        }
        setAmount(tAmount);
        setTotalAmount((tAmount * 1.026).toFixed(2))
    };
    const handleNavigation = (path) => {
        navigate(path);
      };

    return (
        <>
            <div className="w-full h-screen items-center justify-center">
                <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
                    <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
                        <FontAwesomeIcon icon={faArrowLeft} size="lg" />
                    </button>
                    <div className="flex items-center justify-center flex-grow gap-2">
                        <h1 className="text-gray-600 font-semibold text-lg">
                        OnRide Topup
                        </h1>
                    </div>
                </nav>       

                    <div className="flex flex-col items-center bg-white p-2 w-full mt-4 mx-auto">
                            {/* Amount Selection */}
                        <div className="flex flex-col items-center bg-white p-8">
                            { !isCustom && (
                            <div className="flex items-center bg-gray-200 rounded p-4 w-full max-w-xs">
                                <button onClick={decrementAmount} className="w-10 h-10 p-1 text-gray-400">
                                    <FontAwesomeIcon icon={faSquareMinus} className="w-7 h-7 text-red-500"/>
                                </button>
                                <span className="flex-grow text-center text-gray-700 text-4xl font-medium">{amount}</span>
                                <button onClick={incrementAmount} className="w-10 h-10 p-1 text-red-500">
                                    <FontAwesomeIcon icon={faSquarePlus} className="w-7 h-7 text-red-500"/>
                                </button>
                            </div>
                            )
                            }
                            

                            {/* Preset Amount */}
                            <div className="flex flex-col w-full max-w-xs mt-6 space-y-2">
                                <div className="flex space-x-2">
                                    {["500", "1,000", "2,000"].map((amt, index) => (
                                        <button
                                            key={index}
                                            onClick={() => handleAmountChange(parseInt(amt.replace(/,/g, ""), 10))}
                                            className="flex-grow h-10 bg-gray-200 text-gray-700 text-lg font-medium rounded text-center"
                                        >
                                            {amt}
                                        </button>
                                    ))}
                                </div>
                                <div className="flex space-x-2">
                                    {["3,000", "5,000", "10,000"].map((amt, index) => (
                                        <button
                                            key={index}
                                            onClick={() => handleAmountChange(parseInt(amt.replace(/,/g, ""), 10))}
                                            className="flex-grow h-10 bg-gray-200 text-gray-700 text-lg font-medium rounded text-center"
                                        >
                                            {amt}
                                        </button>
                                    ))}
                                </div>
                                <div className="flex space-x-2">
                                    {["Custom"].map((amt, index) => (
                                        <button
                                            key={index}
                                            onClick={() => handleCustom()}
                                            className="flex-grow h-10 bg-gray-200 text-gray-700 text-lg font-medium rounded text-center"
                                        >
                                            {amt}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Ride Code Input */}
                            { isCustom && (
                            <div className="w-full max-w-xs mt-8">
                                <div className="flex items-center border border-red-500 rounded p-2 bg-white">
                                    <img src={bus} alt="Bus Station Icon" className="w-6 h-6 mr-2 text-red-500" />
                                    <input
                                        type="number"
                                        maxLength="6"
                                        placeholder="Custom Amount"
                                        value={amount}
                                        onChange={(e) => { 
                                            setAmount(e.target.value)
                                            setTotalAmount((e.target.value * 1.026).toFixed(2))
                                        }}
                                        className="w-full outline-none"
                                    />
                                </div>
                                <p className="text-xs text-gray-400 mt-2">
                                * Transaction charges applicable 2.6%
                                </p>
                            </div>
                            )}

                            {/* Action Buttons */}
                            <div className="w-full max-w-xs mt-8 space-y-3">
                                <button onClick={handleProceed} className="min-w-80 h-12 bg-red-500 text-white text-lg font-bold rounded">PAY PKR { totalAmount }</button>
                                <button className="w-full h-12 border border-red-500 text-red-500 text-lg font-bold rounded">Cancel</button>
                            </div>
                        </div>
                    </div>
            </div>
            <CustomToastContainer/>
        </>
    );
};

export default OnRideTopup;
